import { isDynamicLoadError } from '@shared/utils'

import ErrorBase from '@components/ErrorBase'

import AppUpdated from './AppUpdated'

export default function Error({ code = 500, error, resetErrorBoundary }) {
  if (isDynamicLoadError(error)) return <AppUpdated />

  return (
    <ErrorBase
      title="Something isn’t working"
      subtitle="That didn’t work, but we are looking into the problem. Please try again later."
      code={code}
      error={error}
      reset={resetErrorBoundary}
    />
  )
}
